import React from 'react';
import RequiredMark from '../Common/RequiredMark';

const WheelFieldLabel = ({ children, required = false, className = '' }) => (
  <label className={`font-semibold block mb-2 wheel-field-label ${className}`}>
    {children}
    {required ? <RequiredMark /> : null}
  </label>
);

export default WheelFieldLabel;
